import React from 'react'
import styled, { css } from "styled-components";

import {
  FormGroup,
} from "xsolla-uikit";
import PAtabs from './PAtabs';






export default function PAh2 ({
  title="",
  indentation="md",
  wrap,
  style,
  border,
  tag = "h2",
  children,
}) {
  let margin = 16
  switch (indentation) {
    case "lg":
      margin = 24;
      break;
    case "md":
      margin = 16;
      break;
    case "sm":
      margin = 8;;
      break;
    case "xs":
      margin = 0;
      break;
    default:
      margin = 16;
    break;
  }


  if (!!title || (!title && !!children)) {
    return(
    // <FormGroup
    //   // border={border}
    //   indentation={indentation}
    //   border = {border ? border : null}
    //   style={{position: 'sticky', top: 0}}
    // >
      <div style={{
        display: 'flex',
        alignItems: 'center',
        ...style,
        // flexGrow: 1,
        // whiteSpace: wrap ? 'nowrap' : 'inherit',
      }}>
        {tag === 'h1' && <Cssh1 wrap={wrap} style={{display: 'block', marginTop: 0, color: 'currentColor', marginBottom: margin}}>{title}</Cssh1>}
        {tag === 'h2' && <Cssh2 wrap={wrap} style={{display: 'block', marginTop: 0, marginBottom: margin}}>{title}</Cssh2>}
        {tag === 'h3' && <Cssh3 wrap={wrap} style={{display: 'block', marginTop: 0, marginBottom: margin}}>{title}</Cssh3>}
        {tag === 'h4' && <Cssh4 wrap={wrap} style={{display: 'block', marginTop: 0, marginBottom: margin}}>{title}</Cssh4>}
        {tag === 'h5' && <Cssh5 wrap={wrap} style={{display: 'block', marginTop: 0, marginBottom: margin}}>{title}</Cssh5>}
        <div style={{flexGrow: 1, justifyContent: 'flex-end', display: 'flex', marginTop: 4}}>
          {children}
        </div>
      </div>
    // </FormGroup>
    )
  } else {
    return null
  }
}




const Cssh1 = styled.h1`
  font-size: 32px;
  white-space: ${({wrap}) => !!wrap ? wrap : 'nowrap'};
  `
const Cssh2 = styled.h2`
  font-size: 28px;
  white-space: ${({wrap}) => !!wrap ? wrap : 'nowrap'};
`

const Cssh3 = styled.h3`
  font-size: 22px;
  white-space: ${({wrap}) => !!wrap ? wrap : 'nowrap'};
`

const Cssh4 = styled.h4`
  white-space: ${({wrap}) => !!wrap ? wrap : 'nowrap'};
`

const Cssh5 = styled.h5`
  white-space: ${({wrap}) => !!wrap ? wrap : 'nowrap'};
`